<template>
  <div class="ca-error">
    <div class="ca-error__card">
      <p class="ca-error__title">无法识别客户门户</p>
      <p class="ca-error__sub">请确认访问链接是否正确，或联系客服人员</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaError',
}
</script>

<style lang="scss">
// /ca/error 是独立路由、不挂 CaLayout，故自行引入同一份汇总样式（样式定义见 ca.scss 中 .ca-error 段）
@import './style/ca.scss';
</style>
